import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useSearchParams, useLoaderData } from "react-router-dom";
import { fetchUserProfile } from "../../store/redux_auth/authSlice";

/**
 * The are routes that can not be accessible to logged users like: login, create account<any type>, etc...
 * This component is to block these routes from logged users.
 *
 * It uses redux auth state to ask is the user is authenticated
 *
 */
const PublicRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, isLoading, user } = useSelector(
    (state) => state.auth,
  );
  const [searchParams] = useSearchParams();

  // Get redirect path from query params, default to "/"
  const redirectPath = searchParams.get("path") || "/";

  // Trigger the fetch if we are on a public route and haven't checked yet
  useEffect(() => {
    if (!isAuthenticated && !user && isLoading) {
      dispatch(fetchUserProfile());
    }
  }, [dispatch, isAuthenticated, user, isLoading]);

  // If Redux is still loading the profile, return nothing (prevents the flash)
  if (isLoading) {
    return null;
  }

  // Once loading is finished, redirect if authenticated, otherwise show children
  return isAuthenticated ? <Navigate to={redirectPath} replace /> : children;
};

export default PublicRoute;
